'use strict';

import 'document-register-element';

class InputFile extends HTMLLabelElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {

  }
  connectedCallback() {
    this.input = this.querySelector('input');
    this.nameArea = this.querySelector('.fileName');
    this.initText = this.nameArea.innerHTML;
    this.clear = this.querySelector('.fileClear');

    this.input.addEventListener('change', () => {
      let name = Object.values(this.input.files).map(file => file.name).join(', ');

      if (name.length) {
        this.nameArea.innerHTML = name;
        this.classList.add('not-empty');
      } else {
        this.nameArea.innerHTML = this.initText;
        this.classList.remove('not-empty');
      }
    });

    if (this.clear) {
      this.clear.addEventListener('click', (e) => {
        if (!this.input.value) return;

        e.preventDefault();

        this.classList.remove('not-empty');
        this.input.value = '';
        this.nameArea.innerHTML = this.initText;
      });
    }
  }
  disconnectedCallback() {
  }
}

window.customElements.define('input-file', InputFile, {extends: 'label'});